import { render, staticRenderFns } from "./PowerupHierarchyNode.vue?vue&type=template&id=788b1642&scoped=true"
import script from "./PowerupHierarchyNode.vue?vue&type=script&lang=js"
export * from "./PowerupHierarchyNode.vue?vue&type=script&lang=js"
import style0 from "./PowerupHierarchyNode.vue?vue&type=style&index=0&id=788b1642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788b1642",
  null
  
)

export default component.exports